import React from 'react'
import { DropdownMenu, DropdownMenuContent, DropdownMenuTrigger } from '@/components/ui/dropdown-menu'
import { PhotoActionItems } from './PhotoSelectionBar'
import type { PhotoAction } from './usePhotoBulkActions'

interface Props {
  /** Viewport point of the right-click; null = closed. */
  at: { x: number; y: number } | null
  actions: PhotoAction[]
  onClose: () => void
}

/** Freelo #33206294: right-click on a photo — the selection bar's actions, anchored at the pointer. */
const PhotoContextMenu: React.FC<Props> = ({ at, actions, onClose }) => {
  if (!at || !actions.length) return null
  return (
    <DropdownMenu key={`${at.x}:${at.y}`} open modal={false} onOpenChange={(open) => !open && onClose()}>
      <DropdownMenuTrigger asChild>
        <span
          aria-hidden
          className="pointer-events-none fixed h-0 w-0"
          style={{ left: at.x, top: at.y }} // ui-drift: dynamic
        />
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="min-w-[12rem]">
        <PhotoActionItems actions={actions} />
      </DropdownMenuContent>
    </DropdownMenu>
  )
}

export default PhotoContextMenu
